import { useEditorStore } from "@/store/editorStore";
import { Slider } from "@/components/ui/slider";
import { ZoomIn, ZoomOut, Maximize2 } from "lucide-react";

export default function ZoomSlider() {
  const zoom = useEditorStore((s) => s.zoom);
  const setZoom = useEditorStore((s) => s.setZoom);

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-full border border-gray-200 shadow-lg px-3 py-1.5 flex items-center gap-2 z-30" data-testid="zoom-slider">
      <button className="text-gray-500 hover:text-[#002FA7]" onClick={() => setZoom(zoom - 0.1)} data-testid="zoom-out">
        <ZoomOut className="w-4 h-4" />
      </button>
      <Slider
        value={[zoom * 100]}
        min={25}
        max={200}
        step={5}
        onValueChange={(v) => setZoom(v[0] / 100)}
        className="w-40"
      />
      <button className="text-gray-500 hover:text-[#002FA7]" onClick={() => setZoom(zoom + 0.1)} data-testid="zoom-in">
        <ZoomIn className="w-4 h-4" />
      </button>
      <span className="text-xs font-mono text-gray-600 w-10 text-right">{Math.round(zoom * 100)}%</span>
      <button className="text-gray-500 hover:text-[#002FA7]" onClick={() => setZoom(1)} title="Fit 100%" data-testid="zoom-reset">
        <Maximize2 className="w-4 h-4" />
      </button>
    </div>
  );
}
